import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'src/app/services/connection.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/services/loader.service';
import { ScreenSizeService } from 'src/app/services/screen-size.service';

@Component({
  selector: 'app-quote-list',
  templateUrl: './quote-list.page.html',
  styleUrls: ['./quote-list.page.scss'],
})
export class QuoteListPage implements OnInit {

  quoteList: any;
  loader: boolean = false;
  mobileSize: boolean = false;
  quoteForm = {
    'qt_dob': '',
    'qt_gender': '',
    'qt_annualIncome': '',
    'qt_lifeCvrAmnt': '',
    'qt_polcyCvrTerm': '',
    'qt_tobacco': '',
    'qt_fname': '',
    'qt_lname': '',
    'qt_mobileNo': '',
    'qt_eduQualification': '',
    'qt_occType': '',
    'qt_email': '',
  }
  age: any;
  preminumamount: any;
  PremAmount: any;

  constructor(private apiService: ConnectionService,
    private router: Router,
    private strg: StorageService, private _datePipe: DatePipe,
    private load: LoaderService,
    private _screenSize: ScreenSizeService) {
    this.preminumamount = "Yearly"
    // this.preminumamount = "Monthly",
    this._screenSize.checkScreenSize().subscribe(res => {
      console.log("screen size", res);
      if (res === "sizeXS" || res === "sizeSM") {
        this.mobileSize = true;
      } else {
        this.mobileSize = false;
      }
    });
  }

  ionViewDidEnter() {
    this.apiService.quoteListArray.subscribe(quoteList => {
      if (quoteList.length === 0) {
        this.router.navigate(['/quote-form']);
      }
      else {
        this.quoteList = quoteList;
      }
    });

    this.strg.getStoreData("quoteFormData").then((resData) => {
      this.quoteForm = resData;
      this.age = this.quoteForm.qt_dob;
      console.log(this.age);
      const today = new Date();
      let dobInput = new Date(this.quoteForm.qt_dob);
      this.age = today.getFullYear() - dobInput.getFullYear();
      const m = today.getMonth() - dobInput.getMonth();
      console.log(this.age, 'reytertuerterrtert');
      if (resData.qt_tobacco == "1") {
        this.quoteForm.qt_tobacco = "Yes"
      }
      else {
        this.quoteForm.qt_tobacco = "No"
      }
      console.log(this.quoteForm.qt_dob, 'response of querywteryew');
      if (this.quoteList.length != 0) {
        this.triggerPublicQuoteEmail();
      }
    });
  }

  ngOnInit() {
    // this.apiService.quoteListArray.subscribe(quoteList => {
    //   if (quoteList.length === 0) {
    //     this.router.navigate(['/quote-form']);
    //   }
    //   else {
    //     this.quoteList = quoteList;
    //     this.triggerPublicQuoteEmail();
    //   }
    // });

    // this.strg.getStoreData("quoteFormData").then((resData) => {
    //   this.quoteForm = resData;
    //   this.age = this.quoteForm.qt_dob;
    //   console.log(this.age);
    //   const today = new Date();
    //   let dobInput = new Date(this.quoteForm.qt_dob);
    //   this.age = today.getFullYear() - dobInput.getFullYear();
    //   const m = today.getMonth() - dobInput.getMonth();
    //   console.log(this.age, 'reytertuerterrtert');
    //   if (resData.qt_tobacco == "1") {
    //     this.quoteForm.qt_tobacco = "Yes"       
    //   }
    //   else{
    //     this.quoteForm.qt_tobacco = "No"       
    //   }
    //   console.log(this.quoteForm.qt_dob, 'response of querywteryew');
    //   if (this.quoteList.length != 0) {
    //     this.triggerPublicQuoteEmail();
    //   }
    // });
  }

  triggerPublicQuoteEmail() {
    let reqData = {
      firstName: this.quoteForm.qt_fname,
      email: this.quoteForm.qt_email,
      products: [],
    }
    console.log("this.quotelist", this.quoteList);
    this.quoteList.forEach(ele => {
      reqData.products.push({
        productName: ele.productName == "iProtect Smart" ? "ICICI Pru iProtect Smart" : ele.productName,
        policyTerm: String(ele.lifeCoverTerm).includes("Year") ? ele.lifeCoverTerm.substring(0, ele.lifeCoverTerm.length - 5).trim() : String(ele.lifeCoverTerm),
        sumAssuredAmount: String(ele.lifeCoverAmount),
        premiumAmount: String(ele.premiumAmount)
      })
    })
    console.log("products array for email trigger", reqData);
    this.apiService.publicQuoteEmailTrigger(reqData).subscribe(res => {
      console.log("triggerEmail", res);
    })
  }

  quoteformdisplay() {
    this.router.navigate(['/quote-form'])
  }

  monthly(value) {
    console.log(value);
  }

  PreAmounttoggle(event) {
    this.quoteList = [];
    console.log(event.detail.value, 'yyyyyyyyyyyyyyyy');
    let modeofpayment;
    let tobacco;
    let tobaccoHDFC;
    let gender;
    let freq;
    if (event.detail.value === "Monthly") {
      modeofpayment = "Monthly"
      freq = "FREQ_4"
    }
    else {
      modeofpayment = "Yearly"
      freq = "FREQ_1"
    }
    if (this.quoteForm.qt_tobacco === "Yes") {
      tobacco = 1;
      tobaccoHDFC = "Y"
    }
    else {
      tobacco = 0;
      tobaccoHDFC = "N"
    }
    if (this.quoteForm.qt_gender === "Male") {
      gender = "GEN_M"
    } else if (this.quoteForm.qt_gender === "Female") {
      gender = "GEN_F"
    } else if (this.quoteForm.qt_gender === "Transgender") {
      gender = "GEN_O"
    }

    let premiumPaymentOption = "Regular Pay";
    if (Number(this.quoteForm.qt_polcyCvrTerm) + Number(this.age) === 99) {
      premiumPaymentOption = "Regular Whole life"
    } else {
      premiumPaymentOption = "Regular Pay"
    }

    let ICICdata = {
      "userId": null,
      "dateOfBirth": this._datePipe.transform(this.quoteForm.qt_dob, 'yyyy-MM-dd'),
      "gender": this.quoteForm.qt_gender,
      "term": this.quoteForm.qt_polcyCvrTerm,
      "deathBenefit": Number(this.quoteForm.qt_lifeCvrAmnt),
      "annualSalary": this.quoteForm.qt_annualIncome,
      "premiumPaymentTerm": this.quoteForm.qt_polcyCvrTerm,
      "tobacco": tobacco,
      "productCode": "T51",
      "modeOfPayment": String(modeofpayment),
      // "premiumPaymentOption": "Regular Pay",
      "premiumPaymentOption": premiumPaymentOption,
      "adhb": 0,
      "lifeCoverOption": "Life",
      "ciBenefit": 0,
      "deathBenefitOption": "Lump-Sum",
      "lumpsumPercentage": 0,
      "firstName": this.quoteForm.qt_fname,
      "middleName": null,
      "lastName": this.quoteForm.qt_lname,
      "email": this.quoteForm.qt_email,
      "occupationType": this.quoteForm.qt_occType,
      "eduQualification": this.quoteForm.qt_eduQualification,
      "moblieNumber": this.quoteForm.qt_mobileNo,
      "pinCode": null,
    }
    let HDFCdata = {
      "sumAssured": this.quoteForm.qt_lifeCvrAmnt,
      "term": this.quoteForm.qt_polcyCvrTerm,
      "premiumPayingTerm": this.quoteForm.qt_polcyCvrTerm,
      "dateOfBirth": this._datePipe.transform(this.quoteForm.qt_dob, 'dd/MM/yyyy'),
      "userId": null,
      "gender": gender,
      "tobaccoStatus": tobaccoHDFC,
      "freq": freq,
      // "productOption": "Life",
      "productOption": "Life Protect",
      "wop": "No",
      "adb": "No",
      "rop": "No",
      "subOption": "Fixed Term",
      "quoteStatus": "FINALIZED",
      "premiumPayingTermOption": "REGULAR",
      "isProposer": "Y",
      "proposerBuyingForItself": "Yes",
      "rider": null,
      "policyInceptionDate": this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
      "quoteGenerationDate": this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
      // "premiumMultiplyingFactor": "",
      "jkStatus": "N",
      "nriFlag": "N",
      "premium": "0",
      "payMethod": "MOP_ONLINE",
      "isInsured": "",
      "firstName": this.quoteForm.qt_fname,
      "lastName": this.quoteForm.qt_lname,
      "email": this.quoteForm.qt_email,
      "mobNoPre": "91",
      // this.quoteForm.qt_mobileNo
      "mobileNumber": this.quoteForm.qt_mobileNo,
      // "nationality": "",
      // "residentStatus": "",
      "state": "MAHA",
      "city": "CTY_MUMB21",
      "topupFlag": "N",
      "opsJourney": "SH",
    }
    console.log(HDFCdata, 'hdfcccccccccccccc')
    this.load.showLoader();
    this.loader = true;
    this.apiService.getIciciQuotation(ICICdata).subscribe(res => {
      // this.load.hideLoader();
      // this.loader = false;
      let productName = "";
      if (res.data.productName === "iProtectSmart") {
        productName = "iProtect Smart"
      }
      console.log(res, 'pppppppppppp');
      this.quoteList.push({
        insurerName: "ICICI Prudential Life Insurance Company Ltd",
        insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/ipru_logo.png",
        productName: productName,
        lifeCoverAmount: res.data.deathBenefit,
        lifeCoverTerm: res.data.term,
        premiumAmount: res.data.totalFirstPremiumShow,
        res: res.data
      });
      this.apiService.quoteListChange(this.quoteList);
      // this.getHDFCguote(HDFCdata);
    }, err => {
      this.load.hideLoader();
      this.loader = false;
    });
  }
  getHDFCguote(data) {
    this.load.showLoader();
    this.apiService.getHdfcQuotation(data).subscribe(res => {
      this.load.hideLoader();
      let hdfcQuote = JSON.parse(res.data);
      console.log("hdfc quote", hdfcQuote);
      this.quoteList.push({
        insurerName: "HDFC Life Insurance Company Limited",
        insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/hdfc-life-logo.png",
        productName: hdfcQuote.prodname,
        lifeCoverAmount: hdfcQuote.sumAssured,
        // lifeCoverTerm: hdfcQuote.POD.term,
        lifeCoverTerm: hdfcQuote.POD.term.substring(0, hdfcQuote.POD.term.length - 5).trim(),
        premiumAmount: hdfcQuote.totPremium,
        res: hdfcQuote
      });
      this.apiService.quoteListChange(this.quoteList);
      this.loader = false;
    }, err => {
      this.load.hideLoader();
    })
  }

  proceedToPlanUpgrade(data) {
    // this.triggerPublicQuoteEmail(data);
    this.strg.setStoreData("quoteForUpgrade", data).then(() => {
      this.router.navigate(['/quote-upgrade']);
    })
    console.log(data);
  }

  // triggerPublicQuoteEmail(data){
  //   let reqData = {
  //     firstName: this.quoteForm.qt_fname,
  //     email: this.quoteForm.qt_email,
  //     productName: "",
  //     sumAssuredAmount: "",
  //     policyTerm: "",
  //     premiumAmount: "",
  //   }
  //   if(data.productName === "iProtectSmart"){
  //     reqData.productName = "ICICI Pru iProtect Smart";
  //     reqData.policyTerm = String(data.term);
  //     reqData.sumAssuredAmount = String(data.deathBenefit);
  //     reqData.premiumAmount = String(data.totalFirstPremiumShow);
  //   } else if(data.prodname === "HDFC Life Click 2 Protect Life"){
  //     reqData.productName = String(data.prodname);
  //     reqData.policyTerm = String(this.quoteForm.qt_polcyCvrTerm);
  //     reqData.sumAssuredAmount = String(data.sumAssured);
  //     reqData.premiumAmount = String(data.totPremium);
  //   }
  //   this.apiService.publicQuoteEmailTrigger(reqData).subscribe(res => {
  //     console.log("triggerEmail",res);
  //   })
  // }

}
